import { list } from '@wix/ambassador-cashier-pay-v2-payment-method/http';
import { ChargeIntent } from '@wix/ambassador-cashier-pay-v2-payment-method/types';
import { TPA_EXPERIMENTS } from '@wix/pricing-plans-common/experiments';
import { ControllerFlowAPI, IHttpClient } from '@wix/yoshi-flow-editor';
import applicationConfig from '../../.application.json';

type ErrorHandler = ControllerFlowAPI['errorHandler'];

export interface PaymentMethodsApi {
  getSupportedChargeIntents(): Promise<ChargeIntent[]>;
}

export class PaymentMethodsService implements PaymentMethodsApi {
  constructor(private httpClient: IHttpClient, private instanceId: string) {}

  public async getSupportedChargeIntents() {
    const response = await this.httpClient.request(
      list({
        accountId: `${applicationConfig.appDefinitionId}:${this.instanceId}`,
      }),
    );

    if (!response.data.paymentMethods) {
      return [];
    }

    return response.data.paymentMethods.reduce<ChargeIntent[]>((prev, curr) => {
      const chargeIntents = curr.supportedChargeIntents?.filter((chargeIntent) => !prev.includes(chargeIntent)) ?? [];
      return [...prev, ...chargeIntents];
    }, []);
  }
}

export class PaymentMethodsServiceWithErrorHandler implements PaymentMethodsApi {
  constructor(private httpClient: IHttpClient, private instanceId: string, private errorHandler: ErrorHandler) {}

  public async getSupportedChargeIntents() {
    const response = await this.errorHandler.withErrorHandler(
      () =>
        this.httpClient.request(
          list({
            accountId: `${applicationConfig.appDefinitionId}:${this.instanceId}`,
          }),
        ),
      { errorCodesMap: {} },
    );

    if (!response.data.paymentMethods) {
      return [];
    }

    return response.data.paymentMethods.reduce<ChargeIntent[]>((prev, curr) => {
      const chargeIntents = curr.supportedChargeIntents?.filter((chargeIntent) => !prev.includes(chargeIntent)) ?? [];
      return [...prev, ...chargeIntents];
    }, []);
  }
}

export function createPaymentMethodsApi(flowAPI: ControllerFlowAPI, instanceId: string) {
  const isErrorHandlerEnabled = flowAPI.experiments.enabled(TPA_EXPERIMENTS.ERROR_HANDLER_TPA);
  if (isErrorHandlerEnabled) {
    return new PaymentMethodsServiceWithErrorHandler(flowAPI.httpClient, instanceId, flowAPI.errorHandler);
  } else {
    return new PaymentMethodsService(flowAPI.httpClient, instanceId);
  }
}
